/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import GlobalDashboardLayout from '../../../../layouts/GlobalDashboardLayout';
import React, { useEffect, useState } from 'react';
import { useI18n } from '@whizz/react-i18n';
import { useMutation } from 'react-query';
import { model } from '@whizz/api-client';
import { Alert, Loader } from '../../../../components';
import { useSearchParam } from 'react-use';
import Button from '../../../../components/button/Button';

export default function ParentEmailUnsubscribe(this: any) {
  const { translate } = useI18n();
  const [ error, setError ] = useState<string | null>(null);
  const [ success, setSuccess ] = useState<string | null>(null);
  const unsubscribeParam = useSearchParam('unsubscribeHash');

  const parentUnsubscribeMutation = useMutation({
    mutationFn: (unsubscribeHash: string) => model.Guardians.unsubscribe(unsubscribeHash),
    onSuccess: () => setSuccess(translate('pages.PARENT_EMAIL_PROCESS.UNSUBSCRIBE.SUCCESS')),
    onError: () => setError(translate('pages.PARENT_EMAIL_PROCESS.UNSUBSCRIBE.ERROR')),
  });

  useEffect(() => {
    if (!unsubscribeParam) {
      setError(translate('pages.PARENT_EMAIL_PROCESS.UNSUBSCRIBE.NO_HASH'));
    }
  }, [ unsubscribeParam ]);

  const submitHandler = (unsubscribeParam: string) => {
    parentUnsubscribeMutation.mutate(unsubscribeParam);
  };

  return (
    <GlobalDashboardLayout hideMenu>

      {unsubscribeParam && parentUnsubscribeMutation.isLoading && (
        <Loader>
        </Loader>
      )}

      {unsubscribeParam && !error && !success && !parentUnsubscribeMutation.isLoading && (
        <div>
          <div className={'m-md'}>
            {translate('pages.PARENT_EMAIL_PROCESS.UNSUBSCRIBE.CONFIRMATION')}
          </div>
          <div className={'flex items-center justify-center'}>
            <Button
              isOutline
              color={'negative'}
              onClick={() => submitHandler(unsubscribeParam ?? '')}
              disabled={parentUnsubscribeMutation.isLoading || parentUnsubscribeMutation.isSuccess || parentUnsubscribeMutation.isError}
            >
              {translate('pages.PARENT_EMAIL_PROCESS.UNSUBSCRIBE.BUTTON')}
            </Button>
          </div>
        </div>
      )}

      {null !== success && (
        <Alert show type={'success'} className={'mb-5'}>
          {success}
        </Alert>
      )}

      {null !== error && (
        <Alert show type={'error'} className={'mb-5'}>
          {error}
        </Alert>
      )}

    </GlobalDashboardLayout>
  );
}
